// Eventos — capa de API. Por ahora sólo lo que se agregó con las jornadas del club y el alta de
// eventos privados; el resto del módulo sigue con `fetch` inline en sus componentes y puede
// migrar acá de a poco. El wrapper HTTP (1002, motivo de negocio) vive en `apiClient.js`.

import { get, post, request } from './apiClient';

// Copia del evento en borrador. Sin body cae una semana después con los mismos tipos de
// entrada; `{ title, startsAt }` la mueven. Devuelve el evento creado.
export const duplicateEvent = (eventId, payload) => post(`manage-events/${eventId}/duplicate`, payload || {});

// GET /manage-events — la lista admin (`{ events: [...] }`, sin paginar, `starts_at DESC`). Cada
// evento trae `hasInclusions`: si alguno de sus tipos de entrada declara qué incluye.
export const listEvents = () => get('manage-events');

// GET /manage-events/:id — el detalle (`{ event, attendees }`); `event.ticketTypes[].inclusions`
// trae lo que declara cada tipo de entrada.
export const getEvent = (eventId) => get(`manage-events/${eventId}`);

// POST /manage-events/private — el alta de un evento privado en un paso: evento publicado y sólo
// mostrador, su tipo de entrada con «Qué incluye», la jornada del salón con las mesas reservadas
// y, después, la venta de las entradas. El cuerpo lo arma `buildPrivateEventBody`.
//
// Lo primero es todo o nada: un rechazo (7610 con el detalle, 7607 de «Qué incluye», 7301 salón
// cerrado, 7304 con la lista de mesas en `err.body.data`) no deja nada creado. La venta va
// DESPUÉS y puede fallar sola: la respuesta trae siempre `event` y, además, `sale` si la venta
// se registró o `saleError` (`{ code, message }`) si el evento quedó creado y la venta no. Si
// trae `warnings` son los avisos del salón al reservar las mesas (`[{ label, reason }]`).
//
// La sucursal viaja DOS veces, y tienen que decir lo mismo: `branchId` en el cuerpo es la del
// evento; la cabecera `x-branch-id` es la de la caja donde el servidor registra la venta. La
// cabecera la pone sola la barra de arriba (`initBranchFetchInterceptor`), salvo con el selector
// en «Todas»: ahí no viaja y el servidor usaría la sucursal por defecto, así que el evento
// quedaría en la sucursal elegida en el formulario y su venta en otra. Se manda explícita; el
// interceptor respeta una cabecera que ya viene puesta.
export const createPrivateEvent = (body) => {
    const branchId = Number(body && body.branchId);
    return request('manage-events/private', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            ...(branchId > 0 ? { 'x-branch-id': String(branchId) } : {}),
        },
        body: JSON.stringify(body || {}),
    });
};
